import { CorreoElectronico } from '@rpe/registro-personas-empresas-lib';

import { EquipamientoProcesamiento } from '../entity-equipamientos-procesamiento/equipamientos-procesamiento.model';
import { Telefono } from '../../contactos/telefonos/telefonos.model';
import { DireccionGeografica } from '../../ubicaciones/direcciones-geograficas/direcciones-geografica.model';

export interface SitioProcesamiento {
  id: number;
  nombre: String;
  entidad_productiva_id: number;
  direccion_geografica: DireccionGeografica;
  telefonos: Telefono[];
  correos_electronico: CorreoElectronico[];
  brinda_servicios_terceros: boolean;
  equipamientos: EquipamientoProcesamiento[];
  especies_id: number[];
}

export function createEmptySitioProcesamiento(): SitioProcesamiento {
  return {
    id: null,
    nombre: null,
    entidad_productiva_id: null,
    direccion_geografica: null,
    correos_electronico: null,
    telefonos: null,
    brinda_servicios_terceros: null,
    equipamientos: null,
    especies_id: null
  };
}

export function createSitioProcesamiento(props: any): SitioProcesamiento {
  return {
    ...createEmptySitioProcesamiento(),
    ...props
  };
}

export interface SitioProcesamientoFormInput {
  /*action: FormActionType;
  especies: Especie[];
  tipos_divisor_muestra: TipoDivisorMuestra[];
  tipos_equipos_laboratorio: TipoEquipamientoLaboratorio[];
  tipos_analisis_laboratorio: TipoAnalisisLaboratorio[];*/
  sitiosProcesamiento: SitioProcesamiento[];
}

export function createEmptySitioProcesamientoFormInput(): SitioProcesamientoFormInput {
  return {
    /*action: FormActionType.Add,
    especies: [],
    tipos_divisor_muestra: [],
    tipos_equipos_laboratorio: [],
    tipos_analisis_laboratorio: [],*/
    sitiosProcesamiento: []
  };
}

export interface ProcesamientoMaquinariaEspecies {
  equipamientoProcesamiento: EquipamientoProcesamiento[];
}

export function createEmptyProcesamientoMaquinariaEspecies(): ProcesamientoMaquinariaEspecies {
  return {
    equipamientoProcesamiento: null,
  };
}

export function createProcesamientoMaquinariaEspecies(
  props: any
): ProcesamientoMaquinariaEspecies {
  return {
    ...createEmptyProcesamientoMaquinariaEspecies(),
    ...props
  };
}
